import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { ScrollToTop } from '@/components/ScrollToTop';
import LayoutWrapper from '@/components/LayoutWrapper';
import PageWithFooter from '@/components/PageWithFooter';

export const RootLayout = () => {
  return (
    <>
      <ScrollToTop />
      <LayoutWrapper>
        <PageWithFooter>
          <Suspense
            fallback={
              <div className="min-h-screen bg-background flex items-center justify-center">
                <div className="animate-pulse space-y-4 w-full max-w-md px-4">
                  <div className="h-8 bg-muted rounded w-3/4 mx-auto" />
                  <div className="h-4 bg-muted rounded w-1/2 mx-auto" />
                </div>
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </PageWithFooter>
      </LayoutWrapper>
    </>
  );
};
